import apiClient from '../api.js';

// Capa de servicios para la administración de la cotización del dólar
// (`unicen.tipo_cambio`). Backend en capas: `UNICEN/modules/economico`.
//
// Las respuestas de error exponen el mensaje vía `.mensaje`, igual que
// `useEstudianteFacturasApi.js`.
//
//   GET  /economico/tipo-cambio/vigente
//        -> { data: { id_tipo_cambio, factor, estado, origen,
//                     id_usuario, usuario, freg } }
//
//        `origen` es 'MANUAL' (la cargó un operador) o 'API_BCB' (vino del
//        Banco Central, por el cron de las 6:00 o por el botón). Con el cron
//        `id_usuario` es null; con el botón lleva a quien lo apretó.
//        404 si nunca se cargó ninguna cotización.
//
//        No hay fecha de vigencia aparte: una cotización rige desde que se
//        inserta, porque el alta reprecia las deudas en el acto y jubila a la
//        anterior. `freg` dice cuándo fue eso.
//
//   GET  /economico/tipo-cambio?limite=
//        -> { data: [ <cotización>, ... ] }  más reciente primero.
//        `limite` es opcional (50 por defecto, tope 500).
//
//   POST /economico/tipo-cambio
//        body: { factor, id_usuario, confirmado }
//        -> 201 { data: { tipo_cambio, anterior, deudas_repreciadas } }
//
//        OJO: esto NO es un alta de catálogo. Registrar una cotización
//        REPRECIA el saldo en bolivianos de todas las deudas cotizadas en
//        dólares que todavía tienen saldo. `deudas_repreciadas` dice cuántas
//        fueron y hay que mostrárselo al operador.
//
//        Errores de dominio esperables:
//          400 factor vacío, con coma decimal, cero, negativo, con más de
//              4 decimales o por encima de 1000.
//          409 `factor` igual al vigente (no se registra nada).
//          409 variación mayor al 20% respecto del vigente. Es el filtro
//              antidedazo: si el valor es correcto, reenviar el mismo body
//              con `confirmado: true`.
//
//   POST /economico/tipo-cambio/actualizar-bcb
//        body: { id_usuario, confirmado }
//        -> 201 { data: { tipo_cambio, anterior, deudas_repreciadas } }
//
//        El backend consulta la API del Banco Central (`tc_oficial.valor`) y
//        registra el valor con origen API_BCB. Mismas guardas y mismos errores
//        409 que el alta manual (igual a la vigente / variación > 20 % que se
//        reenvía con `confirmado: true`). Además:
//          502 la API del BCB no respondió o devolvió un valor inutilizable.
//
//   NO HAY PUT, PATCH NI DELETE, y no es un olvido. `unicen.tipo_cambio` es de
//   SOLO INSERCIÓN: una cotización cargada no se corrige ni se borra. Si alguien
//   carga un valor equivocado, la forma de arreglarlo es cargar el correcto, y
//   quedan las dos filas con su autor y su hora. Así el historial dice la verdad
//   sobre quién puso cada cotización.
//   La base lo impone con el trigger `trg_tipo_cambio_inmutable`, así que
//   tampoco sirve llamar al endpoint por otro camino.

const resource = '/economico/tipo-cambio';

const useTipoCambioApi = {
  obtenerVigente() {
    return apiClient.get(`${resource}/vigente`);
  },

  listarHistorial(limite) {
    return apiClient.get(resource, { params: { limite } });
  },

  registrar(datos) {
    return apiClient.post(resource, datos);
  },

  actualizarDesdeBcb(datos) {
    return apiClient.post(`${resource}/actualizar-bcb`, datos);
  },
};

export default useTipoCambioApi;
